import type { IWebsocketBody } from "@bbj-types/websockets/body";

window.handlers = {};
window.handlersWebsocket = {};

window.publish = (topic, message) => {
  window.dispatchEvent(
    new CustomEvent("pubsub", {
      detail: { topic, message },
    })
  );
};

window.subscribe = (topic, handler) => {
  const topicHandlers = window.handlers[topic] || [];
  topicHandlers.push(handler);
  window.handlers[topic] = topicHandlers;
};

window.unsubscribe = (topic, handler) => {
  const topicHandlers = window.handlers[topic] || [];
  const index = topicHandlers.indexOf(handler);
  index >= 0 && topicHandlers.splice(index, 1);
};

window.addEventListener("pubsub", (ev) => {
  const { topic, message } = ev.detail;
  const topicHandlers = window.handlers[topic] || [];
  for (const handler of topicHandlers) {
    handler(message);
  }
});

window.subscribeWebsocket = (channel, handler) => {
  const channelHandlers = window.handlersWebsocket[channel] || [];
  channelHandlers.push(handler);
  window.handlersWebsocket[channel] = channelHandlers;
};

window.unsubscribeWebsocket = (channel, handler) => {
  const channelHandlers = window.handlersWebsocket[channel] || [];
  const index = channelHandlers.indexOf(handler);
  index >= 0 && channelHandlers.splice(index, 1);
};

export const handleWebsocket = (data: IWebsocketBody) => {
  const channelHandlers = window.handlersWebsocket[data.channel];
  if (!channelHandlers) {
    return;
  }
  for (const handler of channelHandlers) {
    // biome-ignore lint/suspicious/noExplicitAny: TS isn't able to understand and it's not necessary here
    handler(data as any);
  }
};
